import React from "react";
import { motion } from "framer-motion";
import { Sparkles, Rocket } from "lucide-react";

export const TitleSlide = ({ onStart }) => {
  return (
    <div className="slide-content" data-testid="title-slide">
      <div className="max-w-5xl w-full text-center px-4">
        <motion.div
          initial={{ scale: 0, rotate: -90 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 120, damping: 12, delay: 0.1 }}
          className="mx-auto mb-6"
          style={{ width: 220, height: 220 }}
        >
          <div className="globe" data-testid="title-globe" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="inline-flex items-center gap-2 bg-white/90 rounded-full px-4 py-1.5 mb-4 border-2 border-yellow-200"
        >
          <Sparkles className="w-4 h-4 text-amber-500" />
          <span className="font-accent text-sm font-semibold text-slate-700">
            Grade 3 Interactive Presentation
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45, duration: 0.7 }}
          className="font-heading font-bold text-4xl sm:text-5xl lg:text-7xl text-slate-900 leading-tight"
        >
          The{" "}
          <span style={{ color: "#FB923C" }}>New 7</span>{" "}
          <span style={{ color: "#2563EB" }}>Wonders</span>
          <br />
          of the{" "}
          <span style={{ color: "#10B981" }}>World</span>{" "}
          <span className="inline-block">🌍</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.7, duration: 0.6 }}
          className="font-body mt-6 text-base sm:text-lg text-slate-700"
        >
          A magical journey across the planet - discover the most amazing places ever built!
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.9, duration: 0.6 }}
          className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 title-people-grid"
        >
          <div className="bg-white/85 backdrop-blur rounded-2xl px-5 py-3 border-2 border-blue-100 shadow-md">
            <div className="font-accent text-xs uppercase tracking-wider text-slate-500">
              Presented by
            </div>
            <div className="font-heading text-2xl text-slate-900" data-testid="presenter-name">
              Yzabelle 👧
            </div>
          </div>
          <div className="bg-white/85 backdrop-blur rounded-2xl px-5 py-3 border-2 border-emerald-100 shadow-md">
            <div className="font-accent text-xs uppercase tracking-wider text-slate-500">
              For
            </div>
            <div className="font-heading text-2xl text-slate-900" data-testid="teacher-name">
              Ms. Sutherland 👩‍🏫
            </div>
          </div>
          <div className="bg-white/85 backdrop-blur rounded-2xl px-5 py-3 border-2 border-amber-100 shadow-md">
            <div className="font-accent text-xs uppercase tracking-wider text-slate-500">
              Class
            </div>
            <div className="font-heading text-2xl text-slate-900">Grade 3 🎒</div>
          </div>
        </motion.div>

        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.15, duration: 0.6 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          onClick={onStart}
          className="start-btn mt-10"
          data-testid="start-presentation-btn"
        >
          <Rocket className="w-6 h-6" />
          Start Presentation
        </motion.button>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4 }}
          className="font-body text-xs text-slate-600 mt-4"
        >
          Use ← → arrow keys, swipe, or the buttons below to navigate
        </motion.p>
      </div>
    </div>
  );
};
